function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "X-check");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "X-check"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z",
  id: "outline-transparent",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  opacity: 0.200000003
}), /*#__PURE__*/React.createElement("g", {
  id: "check-circle-2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(8.000000, 8.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "x-circle"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.4,
  y1: 5.6,
  x2: 5.6,
  y2: 10.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.6,
  y1: 5.6,
  x2: 10.4,
  y2: 10.4,
  id: "Path"
})))));

var SvgErrorCheck = function SvgErrorCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-check.29d00336.svg";
export { ForwardRef as ReactComponent };